import type { DatePickerAlignment } from './alignment';
import { pickerSurroundingPadding } from './styles';
import { css } from 'emotion';

import { colors } from '../../styles';

/* These variables are not supposed to be used here, they're just
  defined here for organization purposes.
  One or another should be passed to the animation function in order to define
  the animation delay duration in the datePicker components.

  These values should be set in milliseconds. (ms)

  Be aware that animation duration != animation delay, delay is how much time it takes
  for the animation to start.

  The animation duration is always 100ms.
 */
const animationDelay = 100;
const animationDuration = 100;

export const animation = (alignment?: DatePickerAlignment, isDisabled?: boolean) => {
  return {
    calendar: css`
      ${isDisabled ? 'display: none' : ''};
      top: ${-1 * pickerSurroundingPadding}px;
      position: absolute;
      z-index: 2;
      background-color: ${colors.white};
      opacity: 1;

      transition: opacity ${animationDuration}ms linear;
    `,

    filter: css`
      left: 10px;
      top: 45px;
      ${isDisabled ? 'display: none' : ''};
      position: absolute;
      z-index: 2;
      background-color: ${colors.white};
      opacity: 1;
      transition: opacity ${animationDuration}ms linear;
    `,

    singleCalendar: css`
      left: ${-1 * pickerSurroundingPadding}px;
    `,

    multiCalendar: css`
      ${alignment || 'left'}: ${-1 * pickerSurroundingPadding}px;
    `,

    hideCalendar: css`
      opacity: 0;
      visibility: hidden;

      transition:
        visibility 0s ${animationDelay + animationDuration}ms,
        opacity ${animationDuration}ms ${animationDelay}ms linear;
    `,

    navbar: css`
      opacity: 1;
      visibility: visible;

      transition: opacity 100ms linear;
    `,

    hideNavbar: css`
      visibility: hidden;
      opacity: 0;

      transition:
        visibility 0ms 100ms,
        opacity 100ms linear;
    `,
  };
};
